import React from "react";
import './style.less';
import Texty from 'rc-texty';
import 'rc-texty/assets/index.css';
import { Row, Col } from 'antd'

export default class InsuranceContent0 extends React.Component {
    render() {
        return (
            <div className={'insurance-content0'}>
                <h1>
                    <Texty>
                        “全额保险，为您安全飞行和长久使用保驾护航”
                    </Texty>
                </h1>
                <Row justify="center">
                    <Col span={"20"}>
                        <div className={'words desc1'}>
                            <div className={'point'}></div>
                            <div className={'title'}>
                                机损险：
                            </div>
                            <div className={'content'}>
                                保险期内，持有合法执照的使用者造成无人机意外灭失或损坏的，保险人应当按照保险合同约定理赔。
                            </div>
                        </div>
                        <div className={'words-tip'}>
                            <p>适用于中国大陆和大部分国家地区</p>
                        </div>
                    </Col>
                </Row>
                <Row justify="center">
                    <Col span={"20"}>
                        <div className={'words desc2'}>
                            <div className={'point'}></div>
                            <div className={'title'}>
                                第三方责任险：
                            </div>
                            <div className={'content'}>
                                在本保险期内，持有合法执照的使用者在经营过程中发生事故，造成第三方人身、财产损失的，保险人应当按照保险合同约定理赔。
                            </div>
                        </div>
                        <div className={'words-tip'}>
                            <p>仅适用于中国大陆</p>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}
